<sbnb-apps-detail-page
  vendorCode="cleanster"
  name="Cleanster"
  logoTile="/assets/images/apps/cleanster.png"
  builtBy="Cleanster"
  builtByLink="https://cleanster.com"
  [categories]="['Operations']"
  [permissions]="[
    AppPermission.calendarRead,
    AppPermission.propertyListingRead,
    AppPermission.reservationRead,
    AppPermission.financialsRead
  ]"
  email="support@cleanster.com"
  phone="+1(415)906-5605"
  [beta]="false"
  [helpArticles]="[
    {
      id: '7908427',
      title: 'Connecting Hospitable with Cleanster'
    }
  ]">
  <sbnb-image-carousel
    [images]="[
      '/assets/images/apps/cleanster/cleanster-1.jpg',
      '/assets/images/apps/cleanster/cleanster-2.jpg',
      '/assets/images/apps/cleanster/cleanster-3.jpg',
      '/assets/images/apps/cleanster/cleanster-4.jpg',
      '/assets/images/apps/cleanster/cleanster-5.jpg',
      '/assets/images/apps/cleanster/cleanster-6.jpg'
    ]"></sbnb-image-carousel>

  <ng-container description>
    <div>
      <p>
        Cleanster’s affordable SaaS platform empowers cleaning business owners to easily manage their cleaners with
        streamlined tools for scheduling, job assignments, payment tracking, and performance management.
      </p>

      <p>
        Designed for hosts and independent managers, Cleanster offers a cost-effective solution to save time, reduce
        manual work, and improve efficiency for just $2.99/month.
      </p>

      <p>
        With a user-friendly interface and powerful features, business owners can automate workflows, stay organized,
        and focus on growing their client base while ensuring their cleaners deliver consistent results.
      </p>

      <p><strong>Key Benefits:</strong></p>

      <ul class="list list__looser">
        <li>Effortless Scheduling: Simplify cleaner assignments and automate reminders.</li>
        <li>All-in-One Management: Track jobs, cleaner performance, and payments seamlessly.</li>
        <li>Affordable & Accessible: At just $2.99/month, it’s an ideal tool for small teams.</li>
        <li>Grow Your STR business : Save time and scale operations without extra effort.</li>
      </ul>

      <p class="mt-10"><strong>Signup to the “SaaS Platform” to get started.</strong></p>
    </div>
  </ng-container>
</sbnb-apps-detail-page>
